import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface AuditLogEntry {
  id: string;
  actor_id: string;
  actor_role: string | null;
  action: string;
  target_table: string | null;
  target_id: string | null;
  before: Record<string, unknown> | null;
  after: Record<string, unknown> | null;
  request_id: string | null;
  created_at: string;
}

export interface AuditLogFilters {
  action?: string;
  target_table?: string;
  actor_id?: string;
  from?: string;
  to?: string;
  limit?: number;
}

export function useAdminAuditLog(filters: AuditLogFilters = {}) {
  const { action, target_table, actor_id, from, to, limit = 200 } = filters;

  return useQuery({
    queryKey: ["admin-audit-log", action, target_table, actor_id, from, to, limit],
    queryFn: async () => {
      let q = supabase
        .from("admin_audit_log")
        .select("id, actor_id, actor_role, action, target_table, target_id, before, after, request_id, created_at")
        .order("created_at", { ascending: false })
        .limit(limit);

      if (action) q = q.ilike("action", `%${action}%`);
      if (target_table) q = q.eq("target_table", target_table);
      if (actor_id) q = q.eq("actor_id", actor_id);
      if (from) q = q.gte("created_at", from);
      if (to) q = q.lte("created_at", to);

      const { data, error } = await q;
      if (error) throw error;
      return (data as AuditLogEntry[]) ?? [];
    },
    staleTime: 30_000,
  });
}
